<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12>
        <v-card v-if="parking !== null">
          <v-layout row>
            <v-flex xs12>
              <v-tabs v-model="activeTab" centered show-arrows slider-color="primary">
                <v-tab href="#live" active-class="tabs__item--active dps-tab-selected">
                  {{ $t('private_parking_activity_live_tab') }}
                </v-tab>
                <v-tab v-if="parking !== null && parking.type !== 'SENSORLESS'" href="#spots" active-class="tabs__item--active dps-tab-selected">
                  {{ $t('private_parking_activity_spots_tab') }}
                </v-tab>
                <v-tab href="#bookings" active-class="tabs__item--active dps-tab-selected">
                  {{ $t('private_parking_activity_bookings_tab') }}
                </v-tab>
                <v-tab href="#door" active-class="tabs__item--active dps-tab-selected">
                  {{ $t('private_parking_activity_events_tab') }}
                </v-tab>
              </v-tabs>
            </v-flex>
          </v-layout>

          <v-tabs-items v-model="activeTab">
            <v-tab-item value="live">
              <activity-action-buttons :parking-id="parkingId" class="spacing-top"></activity-action-buttons>

              <v-data-table disable-initial-sort hide-actions hide-headers :items="tableData" :rows-per-page-items="rowsPerPageItems">
                <template slot="items" slot-scope="props">
                  <td width="50%">{{ props.item.label }}</td>
                  <td v-if="props.item.chip">
                    <v-chip :color="props.item.class" small disabled outline>{{ props.item.value }}</v-chip>
                  </td>

                  <td v-else-if="props.item.isDate">
                    {{ props.item.value | formatDateTimeLong }}
                  </td>

                  <td v-else>
                    {{ props.item.value }}
                  </td>
                </template>
              </v-data-table>
            </v-tab-item>

            <v-tab-item v-if="parking !== null && parking.type !== 'SENSORLESS'" value="spots">
              <v-card>
                <v-card-title>
                  <parking-spots-table-box :parking-id="parkingId"></parking-spots-table-box>
                </v-card-title>
              </v-card>
            </v-tab-item>

            <v-tab-item value="bookings">
              <v-card>
                <v-card-title>
                  <bookings-table-box :parking-id="parkingId" :parking-is-sensored="parking.type !== 'SENSORLESS'"></bookings-table-box>
                </v-card-title>
              </v-card>
            </v-tab-item>

            <v-tab-item value="door">
              <v-card>
                <v-card-title>
                  <door-events-table :parking-id="parkingId"></door-events-table>
                </v-card-title>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import parkingService from '@/services/parkingService';
import spotService from '@/services/spotService';
import ActivityActionButtons from '@/components/commons/ActivityActionButtons.vue';
import ParkingSpotsTableBox from '@/components/commons/ParkingSpotsTableBox.vue';
import BookingsTableBox from '@/components/commons/BookingsTableBox.vue';
import DoorEventsTable from '@/components/commons/DoorEventsTable.vue';
import keys from '@/store/keys';
import store from '@/store';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'ParkingActivity',
  components: {
    [ActivityActionButtons.name]: ActivityActionButtons,
    [ParkingSpotsTableBox.name]: ParkingSpotsTableBox,
    [BookingsTableBox.name]: BookingsTableBox,
    [DoorEventsTable.name]: DoorEventsTable
  },
  data() {
    return {
      rowsPerPageItems: [25, 50, 100, { text: this.$i18n.t('row_pagination_all'), value: -1 }],
      tableData: [],
      activeTab: 'live',
      parkingId: this.$route.params.id,
      parkingStatus: {},
      parking: null,
      spotsAmount: 0
    };
  },
  created() {
    if (store.state.parkingSelected !== null && this.parkingId === store.state.parkingSelected) {
      this.parking = store.state.parkingSelected;
    }
    this.loadData();
    EventBus.$on(keys.eventOnLanguageChanged, this.onLanguageChanged);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.onLanguageChanged);
  },
  methods: {
    onLanguageChanged() {
      this.rowsPerPageItems = [25, 50, 100, { text: this.$i18n.t('row_pagination_all'), value: -1 }];
    },
    sortPrice(row1, row2) {
      let a = parseFloat(Number(row1.price.replace(/[^0-9-]+/g, '')));
      let b = parseFloat(Number(row2.price.replace(/[^0-9-]+/g, '')));

      return a < b ? -1 : a > b ? 1 : 0;
    },
    loadData() {
      var params = {
        parking: this.parkingId
      };

      parkingService.status(params, this.statusSuccessHandler, this.statusErrorHandler);

      if (this.parking === null) {
        parkingService.summary(params, this.summarySuccessHandler, this.summaryErrorHandler);
      } else {
        if (this.parking.type === 'SENSORLESS') {
          spotService.list(params, this.listSuccessHandler, this.listErrorHandler);
        }
      }
    },
    summarySuccessHandler(data) {
      this.parking = data;
      if (this.parking.type === 'SENSORLESS') {
        let params = {
          parking: this.parkingId
        };
        spotService.list(params, this.listSuccessHandler, this.listErrorHandler);
      }

      store.commit('UPDATE_PARKING_SELECTED', this.parking);
    },
    summaryErrorHandler(error) {
      if (error.status === 404) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'error_404',
          type: 'error'
        });
      }

      this.$router.push({ name: 'Dashboard' });
    },
    listSuccessHandler(data) {
      this.spotsAmount = data.total;
    },
    listErrorHandler() {},
    statusSuccessHandler(data) {
      this.parkingStatus = data;
      this.parkingStatus.statusClass = 'red';
      if (this.parkingStatus.status === 'ACTIVED') {
        this.parkingStatus.statusClass = 'green';
      }

      this.parkingStatus.connectionClass = 'red';
      this.parkingStatus.connectionLabel = 'OFFLINE';
      if (this.parkingStatus.isOnline) {
        this.parkingStatus.connectionClass = 'green';
        this.parkingStatus.connectionLabel = 'ONLINE';
      }

      this.tableData = [
        { label: this.$i18n.t('private_parking_activity_parking_status'), value: this.parkingStatus.status },
        { label: this.$i18n.t('private_parking_activity_parking_connectivity'), value: this.parkingStatus.connectionLabel },
        { label: this.$i18n.t('private_parking_activity_parking_last'), value: this.parkingStatus.lastCheck, isDate: true },
        { label: this.$i18n.t('private_parking_activity_parking_code'), value: this.parkingStatus.masterCode }
      ];
    },
    statusErrorHandler() {}
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/dps-customization.scss';
</style>



// WEBPACK FOOTER //
// src/components/parking/Activity.vue